module.exports = __webpack_public_path__ + "img/videoicon.1b019ad5.png";